/* src/app/components/cbm-item/cbm-item.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.button {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  text-decoration: none;
  display: inline-block;
  margin: 5px;
  width: 290px;
  height: 50px;
  border-radius: 26px;
  border: none;
  padding: 10px;
  color: #5F96BA;
  outline: none !important;
}
.button:disabled {
  box-shadow: none;
  background-color: #BCBCBD !important;
  color: #797A7B !important;
  border: none;
}
.button:disabled:hover {
  box-shadow: none;
}
.button-default {
  outline: none !important;
  background-color: white;
  color: #5F96BA;
  border: 1px solid #5F96BA;
}
.button-default:hover {
  color: #284D76;
  background-color: #9FC6D8;
  border-color: #9FC6D8;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-active {
  background-color: #5F96BA;
  color: #FFF;
}
.button-active:hover {
  background-color: #9FC6D8;
  color: #284D76;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-disabled {
  background-color: #BCBCBD !important;
  color: white !important;
  border: none;
}
.button-disabled:hover {
  box-shadow: none;
}
.button-gradient {
  outline: none !important;
  background-image:
    linear-gradient(
      270deg,
      #171C8F,
      #00B7BD);
  color: white;
  border: none;
}
.button-gradient:hover {
  outline: none !important;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
@media screen and (max-width: 1000px) {
  .button {
    width: 275px;
    font-size: 15px;
  }
}
.cbm-item {
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  font-family: "Gotham-Book", serif;
  align-items: center;
}
.cbm-item-selected {
  border: 1px solid #5F96BA !important;
}
.cbm-item:hover {
  background-color: #EEEEEE;
}
.cmb-circle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #CBCBCB;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  overflow: hidden;
  font-family: "TradeGothic LT Bold", serif;
  font-size: 18px;
  color: #FFF;
}
.cmb-circle-selected {
  background-color: #5F96BA !important;
}
.cbm-choice {
  color: #5F96BA;
  font-size: 18px;
  font-family: "TradeGothic LT Bold", serif;
  display: inline-block;
}
.cbm-detail {
  flex: 1;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detail-recommend {
  font-family: Lato-Medium, serif;
  font-size: 15px;
  color: #9A9B9C;
}
.detail-name {
  font-size: 24px;
  font-weight: bold;
  color: #284D76;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  max-width: 40vw;
  font-family: "Gotham-Bold", serif;
}
.detail-tags {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}
.detail-tags-mobile {
  display: none;
  padding-left: 65px;
}
.detail-tags div,
.detail-tags-mobile div {
  display: inline-block;
  font-size: 13px;
  color: #292929;
  border: 1px solid #9FC0D5;
  background-color: #EFF9FF;
  font-family: "Gotham-Book", serif;
  padding: 5px 7px;
  margin: 2px;
  border-radius: 3px;
}
.detail-view {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: #284D76;
  display: inline-block;
}
.star {
  height: 25px;
  width: 25px;
}
.star-active {
  opacity: 1;
}
.star-inactive {
  opacity: 0.2;
}
.star-container {
  position: relative;
}
.star-container:hover ._tooltip {
  display: block;
}
.pcab {
  position: relative;
}
.pcab:hover ._tooltip {
  display: block;
}
@media screen and (max-width: 1000px) {
  .cbm-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .pcab {
    padding-left: 65px;
  }
  .star-container {
    padding-left: 65px;
  }
  .detail-name {
    width: 100%;
    white-space: normal;
    word-wrap: break-word;
  }
  .detail-tags {
    display: none;
  }
  .detail-view {
    display: none;
  }
  .detail-tags-mobile {
    display: block;
  }
}
@media screen and (max-width: 1000px) and (max-width: 1000px) {
  .searchbar {
    display: flex;
    flex-direction: column;
  }
  .button {
    width: 100%;
  }
  .mobile-hidden {
    display: none !important;
  }
  .desktop-hidden {
    display: unset;
  }
  .filter-container {
    width: 100%;
  }
}
/*# sourceMappingURL=cbm-item.component.css.map */
